import React from 'react';

export default function NoDataIndicator(props) {
  return (
    <div style={{ textAlign: 'center', padding: 20 }}>
      {props.message || 'No Data'}
    </div>
  );
}
